
const routes = [
    {
        meta: {
            title: 'ログイン',
            fullScreen: true
        },
        path: '/login',
        name: 'login',
        component: () => import('@/views/Login')
    },
    {
        meta: {
            title: '基本情報入力',
            fullScreen: true
        },
        path: '/userinfoform',
        name: 'userinfoform',
        component: () => import('@/views/UserInfoForm')
    },
    {
        meta: {
            title: '決済情報入力',
            fullScreen: true
        },
        path: '/payment',
        name: 'payment',
        component: () => import('@/views/PaymentView'),
        beforeEnter: (to, from, next) => {
            window.location.href = '/top/#/plans'
        }
    },
    {
        meta: {
            title: '決済情報の更新',
            fullScreen: true
        },
        path: '/paymentupdate',
        name: 'paymentupdate',
        component: () => import('@/views/PaymentUpdate'),
        beforeEnter: (to, from, next) => {
            window.location.href = '/top/#/profile'
        }
    },
    {
        meta: {
            title: 'ホーム'
        },
        path: '/home',
        name: 'home',
        component: () => import('@/views/Home'),
        children: [
            {
                meta: {
                    title: 'トレーニング動画',
                    back: '/home'
                },
                path: 'training-video',
                name: 'training-video',
                props: true,
                component: () => import('@/views/TrainingVideoPlayer.vue')
            }
        ]    },
    {
        meta: {
            title: '目標設定'
        },
        path: '/goal-settings',
        name: 'goal-settings',
        component: () => import('@/views/GoalSettings')
    },
    {
        meta: {
            title: 'Myデータ'
        },
        path: '/mydata',
        name: 'mydata',
        component: () => import('@/views/MyData')
    },
    // {
    //     meta: {
    //         title: 'イベント一覧',
    //     },
    //     path: '/event-list',
    //     name: 'event-list',
    //     component: () => import('@/views/EventList')
    // },
    // {
    //     meta: {
    //         title: 'イベント詳細',
    //     },
    //     path: '/event-list/detail/:event_id/',
    //     name: 'eventdetail',
    //     component: () => import('@/views/EventDetail')
    // },
    {
        meta: {
            title: 'ランキング',
        },
        path: '/ranking',
        name: 'ranking',
        redirect: { name: 'local_individual_ranking' },
        component: () => import('@/views/Ranking'),
        children: [
            {
                meta: {
                    title: '個人ランキング（チーム内）',
                },
                path: 'individual/local',
                name: 'local_individual_ranking',
                component: () => import('@/views/Ranking')
            },
            {
                meta: {
                    title: '個人ランキング（全国）',
                },
                path: 'individual/national',
                name: 'national_individual_ranking',
                component: () => import('@/views/Ranking')
            },
            {
                meta: {
                    title: 'チームランキング（全国）',
                },
                path: 'team/national',
                name: 'national_team_ranking',
                component: () => import('@/views/Ranking')
            },
        ],
    },
    {
        meta: {
            title: 'ノート'
        },
        path: '/note',
        name: 'note',
        component: () => import('@/views/Note'),
    },
    {
        meta: {
            title: 'ノート記入',
        },
        path: '/note/write_note/:date',
        name: 'write_note',
        component: () => import('@/views/WriteNote')
    },
    {
        meta: {
            title: 'ノート記入確認',
        },
        path: '/note/write_confirm_note',
        name: 'write_confirm_note',
        component: () => import('@/views/WriteConfirmNote')
    },
    {
        meta: {
            title: 'ノート閲覧',
        },
        path: '/note/view_note/:noteId',
        name: 'view_note',
        component: () => import('@/views/ViewNote')
    },
    {
        meta: {
            title: 'ノート下書き編集',
        },
        path: '/note/edit_note/:noteId',
        name: 'edit_note',
        component: () => import('@/views/EditNote')
    },
    {
        meta: {
            title: '機能設定'
        },
        path: '/setting',
        name: 'setting',
        component: () => import('@/views/SettingView')
    },
    {
        meta: {
            title: '測定結果一覧'
        },
        path: '/evaluation',
        name: 'evaluation',
        component: () => import('@/views/EvaluationResult')
    },
    // {
    //     meta: {
    //         title: 'プロフィール'
    //     },
    //     path: '/profile',
    //     name: 'profile',
    //     component: Profile
    // },
    {
        meta: {
            title: '利用ガイド'
        },
        path: '/guide',
        name: 'guide',
        component: () => import('@/views/Guide')
    },
    {
        meta: {
            title: 'お知らせ一覧'
        },
        path: '/information/',
        name: 'information',
        component: () => import('@/views/Information'),
    },
    {
        meta: {
            title: 'お知らせ詳細'
        },
        path: '/information/detail/:infoId',
        name: 'informationdetail',
        component: () => import('@/views/InformationDetail'),
        props: true
    },
    {
        meta: {
            title: 'ユーザーマニュアル・よくある質問',
        },
        path: '/faq',
        name: 'faq',
        component: () => import('@/views/FAQ'),
    },
    // 存在しないpathは、ホーム画面にリダイレクト
    {
        path: '/:pathMatch(.*)*',
        redirect: { name: 'home' }
    }
]

export default routes
